import { useState } from 'react'
import css from './BuyingOptions.styles.scss'
import Plus from '../../../../icons/Plus.svg'
import Minus from '../../../../icons/Minus.svg'
import { Offer } from '../../../../../src/types/offer'
import TextLink from '../../../TextLink/TextLink'
import { StoreIcon } from '../../../StoreIcons/StoreIcons'

interface BuyingOptionProps {
  option: Offer
  onBuyingOptionClick: (offer: Offer) => void
  isGiftCard: boolean
}

const formatPrice = (price?: string | number) => {
  if (!price) return '$0.00'
  const priceString = typeof price === 'string' ? price : price.toString()
  let [dollars, cents] = priceString.split('.')
  cents = cents || '0'
  return `$${dollars}.${cents.padEnd(2, '0')}`
}

const BuyingOption = ({
  option,
  onBuyingOptionClick,
  isGiftCard,
}: BuyingOptionProps) => {
  return (
    <a
      onClick={() => onBuyingOptionClick(option)}
      className={css.buying_option}
    >
      <div className={css.buying_option__info}>
        <StoreIcon
          store={{ name: option.storeIconName }}
          className={css.buying_option__icon}
        />
        <div className={css.buying_option__name}>{option.storeDisplayName}</div>
      </div>
      <div className={css.buying_option__price}>
        {isGiftCard ? '$25 – $1,000' : formatPrice(option.price)}
      </div>
    </a>
  )
}

interface BuyingOptionsProps {
  options?: Array<Offer>
  onBuyingOptionClick: (offer: Offer) => void
  isGiftCard: boolean
}

export const BuyingOptions = ({
  options = [],
  onBuyingOptionClick,
  isGiftCard,
}: BuyingOptionsProps) => {
  const [isExpanded, setIsExpanded] = useState(false)
  const numMinimizedOptionsToShow = 3
  const slicedOptions = isExpanded
    ? options
    : options.slice(0, numMinimizedOptionsToShow)
  const isOptionsSliced = options.length > numMinimizedOptionsToShow

  return (
    <div className={css.buying_options}>
      <div className={css.buying_options__heading}>Buying Options</div>
      {slicedOptions.map((option) => (
        <BuyingOption
          onBuyingOptionClick={onBuyingOptionClick}
          option={option}
          isGiftCard={isGiftCard}
          key={option.url}
        />
      ))}
      {isOptionsSliced && (
        <TextLink
          size="sm"
          variant="default"
          onClick={() => setIsExpanded(!isExpanded)}
          className={css.buying_options__control}
          icon={{ side: 'left', icon: isExpanded ? <Minus /> : <Plus /> }}
        >
          {isExpanded ? 'Show Less' : 'Show More'}
        </TextLink>
      )}
    </div>
  )
}
